module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/info2-9e5306d3176ac155c69f9f4000b40d16.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/info2.svg
// module id = 1237
// module chunks = 0